import { useEffect, useState } from "react";
import React from "react";
import useAuth from "../../context/AuthProvider";
import { TaxTransactionReportModel_Resp } from "../../models/TaxTransactionReportModel";
import { Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, IconButton, InputLabel, MenuItem, Paper, Select, SelectProps, TextField, Typography, Button } from "@mui/material";
import { FieldAttributes, Form, Formik, useField } from "formik";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Swal from "sweetalert2";
import { FMTextField } from "../Elements/input";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { apiClient } from "../../helper/api";

const selectFieldSx = {
    width: '100%',
    '& .MuiSelect-select': { padding: '14.5px 16px' },
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
    '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
    '& .MuiInputBase-input': { padding: '5px 14px !important' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};


interface Iprops {
    StateRuleMatrixCL: TaxTransactionReportModel_Resp,
    handleClose: () => void,
    Open: boolean,
    handleSubmit: () => void
    initValues: TaxTransactionReportModel_Resp
     fetchDataMain: (
        pageSize: number,
        currentPage: number,
        tabValue: number
    ) => void;
    tabValue: number
    completedPage: boolean
}

export const AddEditDiligentSearh: React.FC<Iprops> = ({ handleClose, Open, StateRuleMatrixCL, handleSubmit, initValues,fetchDataMain ,tabValue, completedPage}) => {
    const initialValues: TaxTransactionReportModel_Resp = initValues ? StateRuleMatrixCL : initValues;
    const { user } = useAuth();
    const token = user?.token;
    const [dateCompleted, setDateCompleted] = useState<string>("");

    const shouldDisableDate = (date: Date) => {
        const minDate = new Date('1900-01-01')
        const maxDate = new Date()
        return date < minDate || date > maxDate;
    };

    const handleCloseBox = () => {
        initialValues.needDiligentSearch = '';
        initialValues.diligentSearchCompleted = '';
        setDateCompleted(StateRuleMatrixCL.dateCompleted )
        handleClose()
    }
    const handleDateCompleted = (event: any) => {
        console.log("date completed",dateCompleted)
        if (event) {
            let formattedDate = '';
            try {
                const date = new Date(event);
                const month = ('0' + (date.getMonth() + 1)).slice(-2);  // Add leading zero if needed
                const day = ('0' + date.getDate()).slice(-2);           // Add leading zero if needed
                const year = date.getFullYear();
                
                // Construct the formatted date as MM/dd/yyyy
                formattedDate = `${month}/${day}/${year}`;
            } catch {
                formattedDate = event.toLocaleString();
            }
            setDateCompleted(formattedDate);
        }
    };
// debugger
    const FMSelectCarrierCustom: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";
        const { user } = useAuth();
        const token = user?.token;
        const initialdata = { insuranceCompanyId: 0, name: "" };
        const [Carrier, setCarrier] = useState([initialdata])

        const fetchData = () => {
            apiClient('/Carrier/getCarrierSelect',
                {
                    method: "GET",
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    })
                })
                .then((responseJson) => {
                    if (!responseJson) return
                    // Do something with the response
                    if (responseJson.data != null) {
                        // console.log(responseJson.data)
                        setCarrier(responseJson.data)
                    }
                })
        }

        useEffect(() => {
            fetchData();
        }, [])


        return (
            <React.Fragment>

                <FormControl error={!!errorText} fullWidth sx={{ m: 1 }} >
                    <InputLabel id="State-Select-Label">Carrier</InputLabel>
                    <Select {...field}
                        labelId="State-Select-Label"
                        label="Carrier"
                        value={field.value || ""}
                        className="border-round main-form-2"
                        IconComponent={ExpandMoreIcon}
                    >
                        {/* <MenuItem value={"0"} >Carrier</MenuItem> */}
                        {Carrier.map((carrier, key) =>
                            <MenuItem key={key} value={carrier.insuranceCompanyId}> {carrier.name} </MenuItem>
                        )}
                    </Select>
                    <FormHelperText>{errorText}</FormHelperText>
                </FormControl>
            </React.Fragment>
        )
    }
    const FMSelectTransactionType: React.FC<FieldAttributes<SelectProps>> = ({ variant, ...props }) => {
        const [field, meta] = useField<{}>(props);
        const errorText = meta.error && meta.touched ? meta.error : "";
        const { user } = useAuth();
        const token = user?.token;
        const initialData = { transactionId: 0, transactionTypeName: "" };
        const [transactionTypes, setTransactionTypes] = useState([initialData]);
        const [dateCompleted, setDateCompleted] = useState<string>('');
    
        const fetchTransactionData = () => {
            apiClient(`/TransactionType/getAllTransactionType`, {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
                .then((responseJson) => {
                    if (responseJson?.data == null) return
                    setTransactionTypes(responseJson.data);
                })
        };
    
        useEffect(() => {
            fetchTransactionData();
        }, []);
    
        return (
            <React.Fragment>
                <FormControl error={!!errorText} fullWidth>
                    <InputLabel id="transaction-type-select-label">Transaction Type</InputLabel>
                    <Select
                        {...field}
                        labelId="transaction-type-select-label"
                        label="Transaction Type"
                        value={field.value || ""}
                        className="border-round main-form-2"
                        IconComponent={ExpandMoreIcon}
                    >
                        {transactionTypes.map((transactionType) => (
                            <MenuItem key={transactionType.transactionId} value={transactionType.transactionId}>
                                {transactionType.transactionTypeName}
                            </MenuItem>
                        ))}
                    </Select>
                    <FormHelperText>{errorText}</FormHelperText>
                </FormControl>
            </React.Fragment>
        );
    };
    useEffect(() => {
        // fetchStateData();
        console.log("initialValues",JSON.stringify(initialValues))
        setDateCompleted(initialValues.dateCompleted )
    }, [initialValues])
    return (
        <Dialog
            open={Open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    width: '90%',
                    maxWidth: 900,
                    minHeight: '50vh',
                    maxHeight: '90vh',
                    borderRadius: 2,
                    boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
                },
            }}
            sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
        >
            <DialogTitle
                sx={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 1,
                    py: 2,
                    px: 3,
                    background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                    color: '#fff',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <SearchOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                    <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                        Diligent Search
                    </Typography>
                </Box>
                <IconButton
                    onClick={handleCloseBox}
                    sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                    aria-label="Close dialog"
                >
                    <CloseOutlinedIcon />
                </IconButton>
            </DialogTitle>

            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validateOnChange={true}
                onSubmit={(data, { setSubmitting }) => {
                    apiClient('/DiligentSearch/AddEditDiligentSearch', {
                        method: 'POST',
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`,
                        }),
                        body: JSON.stringify({
                            ...data,
                            dateCompleted: new Date(dateCompleted).toISOString()
                        })
                    })
                        .then((res) => {
                            if (!res) return;
                            handleSubmit();
                            setSubmitting(true);
                            Swal.fire({
                                title: "Data Successfully saved",
                                text: "",
                                icon: "success",
                                confirmButtonText: "OK",
                            });
                            fetchDataMain(50, 1, tabValue);
                        }).catch((error) => {
                            console.log(error);
                        });
                }}
            >
                {({ values, isSubmitting, setFieldValue, errors }) => (
                    <Form className="main-form">
                        <DialogContent sx={{ px: { xs: 2, sm: 3 }, py: 3, overflow: 'auto' }}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Filing details
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Insured Name</FormHelperText>
                                                    <FMTextField name="insuredName" margin="dense" disabled label={null} placeholder="Insured Name" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Client</FormHelperText>
                                                    <FMTextField name="client" margin="dense" disabled label={null} placeholder="Client" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Policy Number</FormHelperText>
                                                    <FMTextField name="policyNumber" disabled margin="dense" label={null} placeholder="Policy Number" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Diligent Search Notes</FormHelperText>
                                                    <FMTextField name="diligentSearchNotes" margin="dense" label={null} placeholder="Diligent Search Notes" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Policy Effective Date</FormHelperText>
                                                    <FMTextField name="policyEffDate" margin="dense" disabled label={null} placeholder="Policy Effective Date" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Policy Expiration Date</FormHelperText>
                                                    <FMTextField name="policyExpDate" margin="dense" disabled label={null} placeholder="Policy Expiration Date" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Gross Premium</FormHelperText>
                                                    <FMTextField name="grossPremium" margin="dense" disabled label={null} placeholder="Gross Premium" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="overline" sx={{ color: 'text.secondary', fontWeight: 600, letterSpacing: '0.08em', display: 'block', mb: 1 }}>
                                        Diligent search status
                                    </Typography>
                                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50' }}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Need Diligent Search</FormHelperText>
                                                    <Select
                                                        name="needDiligentSearch"
                                                        value={initialValues.needDiligentSearch?.toUpperCase() ?? ''}
                                                        onChange={(event) => {
                                                            setFieldValue("needDiligentSearch", event.target.value);
                                                            initialValues.needDiligentSearch = event.target.value;
                                                        }}
                                                        displayEmpty
                                                        fullWidth
                                                        variant="outlined"
                                                        IconComponent={ExpandMoreIcon}
                                                        sx={selectFieldSx}
                                                    >
                                                        <MenuItem value="TRUE">TRUE</MenuItem>
                                                        <MenuItem value="FALSE">FALSE</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Diligent Search Completed</FormHelperText>
                                                    <Select
                                                        name="diligentSearchCompleted"
                                                        value={initialValues.diligentSearchCompleted?.toUpperCase() ?? ''}
                                                        onChange={(event) => {
                                                            setFieldValue("diligentSearchCompleted", event.target.value);
                                                            initialValues.diligentSearchCompleted = event.target.value;
                                                        }}
                                                        displayEmpty
                                                        fullWidth
                                                        variant="outlined"
                                                        IconComponent={ExpandMoreIcon}
                                                        sx={selectFieldSx}
                                                    >
                                                        <MenuItem value="TRUE">TRUE</MenuItem>
                                                        <MenuItem value="FALSE">FALSE</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <Grid item xs={12} sm={6}>
                                                    <FormControl sx={{ width: '100%' }}>
                                                        <FormHelperText className="formtexthelper-heading">Date Completed</FormHelperText>
                                                        <DatePicker
                                                            value={dateCompleted}
                                                            onChange={handleDateCompleted}
                                                            renderInput={(params) => (
                                                                <TextField fullWidth size="small" {...params} sx={textFieldSx} />
                                                            )}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </LocalizationProvider>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Suspended</FormHelperText>
                                                    <FMTextField name="suspended" margin="dense" disabled label={null} placeholder="Suspended" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Transaction Type</FormHelperText>
                                                    <FMTextField name="transactionType" margin="dense" disabled label={null} placeholder="Transaction Type" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">Carrier</FormHelperText>
                                                    <FMTextField name="carrier" margin="dense" disabled label={null} placeholder="Carrier" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <FormControl sx={{ width: '100%' }}>
                                                    <FormHelperText className="formtexthelper-heading">NAIC</FormHelperText>
                                                    <FMTextField name="naic" margin="dense" disabled label={null} placeholder="NAIC" type="text" fullWidth variant="outlined" sx={textFieldSx} />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                        </DialogContent>

                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                gap: 1.5,
                                borderTop: 1,
                                borderColor: 'divider',
                                backgroundColor: 'grey.50',
                                flexWrap: 'wrap',
                            }}
                        >
                            <Button
                                variant="outlined"
                                size="medium"
                                onClick={handleCloseBox}
                                startIcon={<CloseOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    borderColor: '#e2e8f0',
                                    color: '#475569',
                                    '&:hover': {
                                        borderColor: '#2099d2',
                                        backgroundColor: '#2099d214',
                                        color: '#2099d2',
                                    },
                                }}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                size="medium"
                                type="submit"
                                disabled={isSubmitting}
                                startIcon={<SaveOutlinedIcon />}
                                sx={{
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    backgroundColor: '#2099d2',
                                    '&:hover': { backgroundColor: '#176990' },
                                    px: 2.5,
                                }}
                            >
                                Submit
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}
